
import { Vue, Component, Prop } from 'vue-property-decorator';

 @Component({})
export default class InfoTooltip extends Vue {
  @Prop({ default: 'top' }) position!: 'top' | 'bottom' | 'left' | 'right';
  @Prop({ default: 0 }) customOpenDelay!: number
}
